type Props = {
  step: 1 | 2 | 3;
  maxReached: 1 | 2 | 3;
  primaryColor: string;
  secondaryColor: string;
  onStepClick: (step: 1 | 2 | 3) => void;
};

export function CadastroEmpresaProgress({
  step,
  maxReached,
  primaryColor,
  secondaryColor,
  onStepClick,
}: Props) {
  const steps: Array<1 | 2 | 3> = [1, 2, 3];

  return (
    <div className="mb-6 w-full" aria-label="Progresso do cadastro">
      <div className="flex w-full items-center">
        {steps.map((n, idx) => {
          const reached = n <= maxReached;
          const usePrimary = reached;
          const circleColor = usePrimary ? primaryColor : secondaryColor;

          return (
            <div key={n} className={`flex items-center ${idx < steps.length - 1 ? "flex-1" : ""}`}>
              <button
                type="button"
                disabled={!reached}
                onClick={() => reached && onStepClick(n)}
                className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-sm font-semibold transition-opacity disabled:cursor-default enabled:cursor-pointer enabled:hover:opacity-90"
                style={{
                  backgroundColor: usePrimary ? primaryColor : "transparent",
                  color: usePrimary ? "#fff" : secondaryColor,
                  border: `2px solid ${circleColor}`,
                }}
                aria-label={`Etapa ${n}`}
                aria-current={n === step ? "step" : undefined}
              >
                {n}
              </button>
              {idx < steps.length - 1 ? (
                <div
                  className="mx-1 h-0.5 min-w-[12px] flex-1 rounded-full"
                  style={{ backgroundColor: n < maxReached ? primaryColor : secondaryColor }}
                  aria-hidden
                />
              ) : null}
            </div>
          );
        })}
      </div>
    </div>
  );
}
